import { useOutlet, useMatches } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@nazka/nazka.mapframe.components';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';

import GraphPanel from '@App/components/GraphPanel/GraphPanel.jsx';
import { setGraphCollapsed } from '@App/components/GraphPanel/PotentialGraph/potential-graph.store';
import Map from '@App/components/Map/Map';

import './map-layout.css';

function MapLayout() {
  const outlet = useOutlet();
  const matches = useMatches();
  const currentRoute = matches[matches.length - 1];
  const routeHandle = currentRoute?.handle || {};
  const dispatch = useDispatch();
  const isCollapsed = useSelector(state => state.flowingWaterGraph.isCollapsed);

  const {
    showPotentialGraphPanel,
    showTimelineGraphPanel,
  } = routeHandle;
  const showGraphPanel = showPotentialGraphPanel || showTimelineGraphPanel;
  const panelType = showPotentialGraphPanel
    ? 'potential'
    : (showTimelineGraphPanel ? 'timeline' : null);
  const reopenLabel = showTimelineGraphPanel ? 'Tijdsgrafiek' : 'Potentieelgrafiek';

  const [map, setMap] = useState();

  useEffect(() => {
    dispatch(setGraphCollapsed(false));
  }, [dispatch, panelType]);

  useEffect(() => {
    if (!map) return undefined;

    const frameId = requestAnimationFrame(() => map.resize());
    return () => cancelAnimationFrame(frameId);
  }, [map, showGraphPanel, isCollapsed]);

  const isPanelVisible = showGraphPanel && !isCollapsed;

  return (
    <div className={`map-layout map-layout--${isPanelVisible ? 'show-graph-panel' : 'hide-graph-panel'}`}>
      <div className="map-layout__map">
        <Map map={map} setMap={setMap} outlet={outlet} />
        {showGraphPanel && isCollapsed && (
          <button
            type="button"
            className="map-layout__reopen"
            onClick={() => dispatch(setGraphCollapsed(false))}
          >
            <Icon icon={faChevronUp} size="16px" />
            {reopenLabel}
          </button>
        )}
      </div>
      {isPanelVisible && (
        <div className="map-layout__graph-panel">
          <GraphPanel />
        </div>
      )}
    </div>
  );
}

export default MapLayout;
